var _rect, _g, _path, _path2, _path3, _path4, _g2, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_2856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#0067C2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V7.66667H23V0H0Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.3335V23.0002H23V15.3335H0Z",
    fill: "#4D8B1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.1665H-0.5V7.6665V15.3332V15.8332H0H23H23.5V15.3332V7.6665V7.1665H23H0Z",
    fill: "#E31C1C",
    stroke: "#F5FBFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1044 3.86273C14.2685 3.46911 14.7098 3.03928 15.4282 2.57324C15.4529 2.55723 15.4828 2.55631 15.5081 2.57079C15.5511 2.59528 15.5689 2.65585 15.5477 2.70595L8.10324 20.5579L7.71564 20.3368L14.2779 4.60043C13.9807 4.54382 13.9229 4.29792 14.1044 3.86273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8877 3.86273C9.06918 4.29792 9.01134 4.54382 8.71418 4.60043L15.2764 20.3368L14.8888 20.5579L7.44435 2.70595C7.42317 2.65585 7.441 2.59528 7.48394 2.57079C7.50932 2.55631 7.53914 2.55723 7.56382 2.57324C8.28227 3.03928 8.72356 3.46911 8.8877 3.86273Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 20.0749C12.3597 20.0749 15.8125 16.4618 15.8125 12.0047C15.8125 7.54771 12.3597 3.93457 11.5 3.93457C10.6403 3.93457 7.1875 7.54771 7.1875 12.0047C7.1875 16.4618 10.6403 20.0749 11.5 20.0749Z",
    fill: "#E31C1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_2856",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 9,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 20.0749C12.3597 20.0749 15.8125 16.4618 15.8125 12.0047C15.8125 7.54771 12.3597 3.93457 11.5 3.93457C10.6403 3.93457 7.1875 7.54771 7.1875 12.0047C7.1875 16.4618 10.6403 20.0749 11.5 20.0749Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59377 19.0662C6.92819 19.0662 9.63127 15.9047 9.63127 12.0048C9.63127 8.10486 6.92819 4.94336 3.59377 4.94336C0.259355 4.94336 -2.44373 8.10486 -2.44373 12.0048C-2.44373 15.9047 0.259355 19.0662 3.59377 19.0662Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4063 19.0662C22.7407 19.0662 25.4438 15.9047 25.4438 12.0048C25.4438 8.10486 22.7407 4.94336 19.4063 4.94336C16.0719 4.94336 13.3688 8.10486 13.3688 12.0048C13.3688 15.9047 16.0719 19.0662 19.4063 19.0662Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6725 10.925C12.0662 10.5979 12.3625 9.17308 12.3625 7.46496C12.3625 5.75683 12.0662 4.33202 11.6725 4.00488V10.925ZM11.2413 10.834C10.8913 10.3841 10.6375 9.04588 10.6375 7.46496C10.6375 5.88404 10.8913 4.5458 11.2413 4.09589V10.834ZM11.2413 13.1748V19.913C10.8913 19.4631 10.6375 18.1248 10.6375 16.5439C10.6375 14.963 10.8913 13.6247 11.2413 13.1748ZM11.6725 20.004V13.0838C12.0662 13.411 12.3625 14.8358 12.3625 16.5439C12.3625 18.252 12.0662 19.6768 11.6725 20.004Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.9956C11.9764 10.9956 12.3625 11.4473 12.3625 12.0044C12.3625 12.5615 11.9764 13.0132 11.5 13.0132C11.0237 13.0132 10.6375 12.5615 10.6375 12.0044C10.6375 11.4473 11.0237 10.9956 11.5 10.9956Z",
    fill: "#F5FBFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_2856)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_2856",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKes);
export default __webpack_public_path__ + "static/media/KES.7b04884acc792a5c9c2edace0f82d3da.svg";
export { ForwardRef as ReactComponent };